import * as React from 'react';
import { CrehanaTFunction } from 'crehana-i18n';

import Checkbox from 'crehana-ui/Checkbox';

import { useTranslation } from 'Jsx/Shared/Hooks/useTranslation';
import localeEs from 'Jsx/MainMenu/locales/es';

export const rulesForRHFControllerComponent = (t: CrehanaTFunction) => ({
  required: {
    value: true,
    message: t('AUTH_VALIDATION_LEGALS_REQUIRED', {
      defaultValue: localeEs.es.translation.AUTH_VALIDATION_LEGALS_REQUIRED,
    }),
  },
});

export const LegalErrorMessage: React.FC<{ message: string }> = ({
  message,
}) => (
  <span className="font-legals text-red-main block mt-4" role="alert">
    {message}
  </span>
);

type LegalCheckboxProps = {
  onChange(value: any): void;
  onBlur: React.DOMAttributes<HTMLInputElement>['onBlur'];
  value?: boolean;
  darkMode?: boolean;
};

const LegalCheckbox: React.FC<LegalCheckboxProps> = ({
  onBlur,
  onChange,
  value,
  darkMode,
}) => {
  const { t } = useTranslation();

  return (
    <Checkbox
      small
      darkMode={darkMode}
      wrapperProps={{ id: 'legal-checkbox' }}
      label={
        <React.Fragment>
          {t('LEGALS_TEXT_1', {
            defaultValue: localeEs.es.translation.LEGALS_TEXT_1,
          })}
          <a
            href="/legal/"
            target="_blank"
            className="font-caption text-secondary-main lg:text-gray-dark lg:hover:text-secondary-main"
            style={{
              textDecoration: 'none',
            }}
          >
            {t('LEGALS_TEXT_2', {
              defaultValue: localeEs.es.translation.LEGALS_TEXT_2,
            })}
          </a>
          de Crehana.
        </React.Fragment>
      }
      onChange={event => {
        const { checked } = event.target;

        onChange(!checked);
      }}
      onBlur={onBlur}
      checked={value}
    />
  );
};

export default LegalCheckbox;
